import { render, staticRenderFns } from "./MasterVersion.vue?vue&type=template&id=5720684d&scoped=true&"
import script from "./MasterVersion.vue?vue&type=script&lang=js&"
export * from "./MasterVersion.vue?vue&type=script&lang=js&"
import style0 from "./MasterVersion.vue?vue&type=style&index=0&id=5720684d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5720684d",
  null
  
)

export default component.exports